import { useMutation } from 'react-query';
import { authFetch } from '../../../CommonUtils/authFetch';
import { httpBodyOptions } from '../../../CommonUtils/httpBodyOptions';

interface UpdateItemDTO {
  itemId: string;
}

const updateItem = async ({
  clientId,
  itemId,
  isDataReconciliation,
}: {
  clientId: string | number;
  itemId: string;
  isDataReconciliation: boolean;
}): Promise<UpdateItemDTO> =>
  authFetch('/Consumer/PlaidAccountsLinking/UpdateItem', {
    method: 'POST',
    ...httpBodyOptions({ clientId, itemId, isDataReconciliation }),
  });

export const usePlaidUpdateItemMutation = () => {
  return useMutation(updateItem);
};
